import type BoltMetaArgs from 'types/BoltMetaArgs';

import { appendTrailingSlash } from './trailingSlash';

export function getCanonicalUrl(args: BoltMetaArgs, canonicalUrl?: string) {
  if (canonicalUrl) return canonicalUrl;

  const { baseUrl } = args.matches[0].data.region;

  return `${baseUrl}${appendTrailingSlash(args.location.pathname)}`;
}
